module.exports = __webpack_public_path__ + "img/instyle-plus-front.11da0239.png";